import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import "./Contact.css";
import Rotate from "react-reveal/Rotate";
import LightSpeed from "react-reveal/LightSpeed";
import {BsGithub, BsLinkedin, BsTwitter } from "react-icons/bs";
const Contact = () => {
  const [name, setname] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  //handle submit button
  useEffect(()=>{
    console.log(process.env.REACT_APP_SERVER);
  },[])
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!name || !email || !msg) {
        toast.error("PLease Provide all fields");
      }
      console.log("called");
      const res = await axios.post(`${process.env.REACT_APP_SERVER}/api/v1/portfolio/sendEmail`, {
        name,
        email,
        msg,
      });
      //validation success
      if (res.data.success) {
        console.log(res.data.message)
        toast.success(res.data.message);
        setname("");
        setEmail("");
        setMsg("");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };
  return (
    <>
      <div className=" contact" id="contact">
        <div className="card card0 border-0">
          <div className="row">
            <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12">
              <div className="card1">
                <div className="row border-line">
                  <LightSpeed>
                    <img
                      src="https://img.freepik.com/free-photo/hot-line-contact-us-call-center-search-interface_53876-124009.jpg?w=2000"
                      alt="ocontact"
                      className="image"
                    />
                  </LightSpeed>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <Rotate>
                <div className="card2 d-flex card border-0 px-4 py-5">
                  <div className="row">
                    <div className="row">
                      <h6>
                        Contact With
                        <a href="https://www.linkedin.com/in/akash-kumar-611344226/" target="_blank" rel="noreferrer">
                          <BsLinkedin color="blue" size={30} className="ms-2" />
                        </a>
                        <a href="https://github.com/AAKASHO" target="_blank" rel="noreferrer" >
                        <BsGithub color="black" size={30} className="ms-2" />
                        </a>
                      
                      <a href="https://twitter.com/KumarAkash33005" target="_blank" rel="noreferrer" >
                        <BsTwitter color="blue" size={30} className="ms-2" />
                      </a>

                      </h6>
                    </div>

                    <div className="row px-3 mb-4">
                      <div className="line" />
                      <small className="or text-center">OR</small>
                      <div className="line" />
                    </div>
                    <div className="row px-3">
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter your Name"
                        className="mb-3"
                        value={name}
                        onChange={(e) => setname(e.target.value)}
                      />
                    </div>
                    <div className="row px-3">
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter Your Email Address"
                        className="mb-3"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="row px-3">
                      <textarea
                        type="text"
                        name="msg"
                        placeholder="Write your message"
                        className="mb-3"
                        value={msg}
                        onChange={(e) => setMsg(e.target.value)}
                      />
                    </div>

                    <div className="row px-3">
                      <button className="button" onClick={handleSubmit}>
                        SEND MESSAGE
                      </button>
                    </div>
                    {loading&&<h6>Sending...</h6>}
                  </div>
                </div>
              </Rotate>
        <div>
        </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
